/**
 * Ensure date/month strings sent to the API use ASCII digits (0-9).
 * In RTL/Arabic locale, moment().format() can produce Arabic-Indic (٠١٢…) or
 * Eastern Arabic-Indic / Persian (۰۱۲…) numerals. APIs expect ASCII YYYY-MM-DD / YYYY-MM.
 */
const NON_ASCII_DIGIT_TO_ASCII: Record<string, string> = {
  '٠': '0',
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
  '۰': '0',
  '۱': '1',
  '۲': '2',
  '۳': '3',
  '۴': '4',
  '۵': '5',
  '۶': '6',
  '۷': '7',
  '۸': '8',
  '۹': '9',
};

/** Map Arabic-Indic / Persian digits to ASCII `0-9`; leave all other characters unchanged. */
export function toAsciiDigits(value: string | undefined | null): string {
  if (value == null || typeof value !== 'string') {
    return '';
  }
  let out = value;
  for (const [ar, ascii] of Object.entries(NON_ASCII_DIGIT_TO_ASCII)) {
    out = out.split(ar).join(ascii);
  }
  return out;
}

export function ensureAsciiDateString(value: string | undefined | null): string {
  if (value == null || typeof value !== 'string') {return '';}
  return toAsciiDigits(value).trim();
}

/** Stable YYYY-MM-DD-style key for lookups/equality when either side may use Arabic digits. */
export function toAsciiDateKey(value: string | undefined | null): string {
  const ascii = ensureAsciiDateString(value);
  return ascii || (typeof value === 'string' ? value.trim() : '');
}

export function isSameAsciiDate(a: string | undefined | null, b: string | undefined | null): boolean {
  const ka = toAsciiDateKey(a);
  const kb = toAsciiDateKey(b);
  return ka.length > 0 && ka === kb;
}
